export type MyGoalsTypeFilter = 'objective' | 'kpi';
export type MyGoalsScopeFilter = 'personal' | 'team' | 'company';
export type MyGoalsPerformanceFilter =
  | 'on_track'
  | 'at_risk'
  | 'behind'
  | 'upcoming'
  | 'no_status';
export type MyGoalsLifecycleFilter = 'all' | 'active' | 'ended' | 'overdue';
export type MyGoalsSort = 'newest' | 'oldest' | 'highest_progress' | 'due_date';

export interface MyGoalsFilters {
  types: MyGoalsTypeFilter[];
  scopes: MyGoalsScopeFilter[];
  performance: MyGoalsPerformanceFilter[];
}

export interface MyGoalsPeriod {
  starts: string;
  ends: string;
  label: string;
  year: number;
  quarter: number | 'custom';
}

export const emptyMyGoalsFilters: MyGoalsFilters = {
  types: [],
  scopes: [],
  performance: [],
};
